import Vue from 'vue'

Vue.filter('integer', (value) => {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
})
